/* Neu Appliance Outlet — Neu Shield Extended Protection (task 86e2a4jnq). Loaded globally.
   - PDP: on a qualifying appliance (#neu-warranty), render 3yr/5yr options (both or none) priced by tier,
     plus a "What's covered?" popup. Chosen plan -> window.__neuWarranty, added by neu-connections.js.
   - CART: for each qualifying appliance added WITHOUT a plan (.neu-cart-upsell placeholder), show an
     inline 3yr/5yr upsell; adding links the plan to that appliance via _neu_warranty_for.
   Pricing tiers = NEU Shield retail sheet. "Combination" = laundry centers / all-in-ones / wall-oven
   microwave-oven combos; everything else is "Major". */
(function () {
  'use strict';
  if (window.__neuWarrantyLoaded) return;   // guard: file may be included on the PDP and globally
  window.__neuWarrantyLoaded = true;

  var PLANS = {
    major: {
      'Under $500':   { y3: { id: '46870445654189', price: 119 }, y5: { id: '46870445686957', price: 219 } },
      'Under $1,000': { y3: { id: '46870445719725', price: 139 }, y5: { id: '46870445752493', price: 239 } },
      'Under $1,500': { y3: { id: '46870445785261', price: 149 }, y5: { id: '46870445818029', price: 249 } },
      'Under $2,500': { y3: { id: '46870445850797', price: 169 }, y5: { id: '46870445883565', price: 269 } },
      'Under $3,500': { y3: { id: '46870445916333', price: 199 }, y5: { id: '46870445949101', price: 299 } },
      'Under $5,000': { y3: { id: '46870445981869', price: 299 }, y5: { id: '46870446014637', price: 399 } },
      'Under $7,500': { y3: { id: '46870446047405', price: 399 }, y5: { id: '46870446080173', price: 499 } }
    },
    combination: {
      'Under $1,000': { y3: { id: '46870446112941', price: 199 }, y5: { id: '46870446145709', price: 299 } },
      'Under $2,000': { y3: { id: '46870446178477', price: 299 }, y5: { id: '46870446211245', price: 399 } },
      'Under $3,000': { y3: { id: '46870446244013', price: 399 }, y5: { id: '46870446276781', price: 499 } },
      'Under $4,000': { y3: { id: '46870446309549', price: 499 }, y5: { id: '46870446342317', price: 599 } },
      'Under $5,000': { y3: { id: '46870446375085', price: 599 }, y5: { id: '46870446407853', price: 699 } }
    }
  };
  var BANDS = {
    major: [[500, 'Under $500'], [1000, 'Under $1,000'], [1500, 'Under $1,500'], [2500, 'Under $2,500'], [3500, 'Under $3,500'], [5000, 'Under $5,000'], [Infinity, 'Under $7,500']],
    combination: [[1000, 'Under $1,000'], [2000, 'Under $2,000'], [3000, 'Under $3,000'], [4000, 'Under $4,000'], [Infinity, 'Under $5,000']]
  };
  function bandKey(type, price) { var b = BANDS[type]; for (var i = 0; i < b.length; i++) if (price < b[i][0]) return b[i][1]; return b[b.length - 1][1]; }
  function tierFor(type, price) { type = (type === 'combination') ? 'combination' : 'major'; return PLANS[type][bandKey(type, price)]; }
  function money(n) { return '$' + Number(n).toFixed(Number(n) % 1 ? 2 : 0); }
  var LOGO = '';
  window.NeuWarranty = { tierFor: tierFor, money: money };

  /* ================= PDP widget ================= */
  function initPdp() {
    var host = document.getElementById('neu-warranty');
    if (!host || host.dataset.neuReady) return;
    host.dataset.neuReady = '1';
    var type = host.getAttribute('data-type');
    var price = parseFloat(host.getAttribute('data-price') || '0');
    var isSet = host.getAttribute('data-wdset') === '1';   // washer/dryer set = TWO appliances; price per appliance
    var qty = isSet ? 2 : 1;                                // charge one plan per appliance (client: "double price is fine")
    var forVariant = host.getAttribute('data-variant') || '';
    LOGO = host.getAttribute('data-logo') || LOGO;
    var tier = tierFor(type, isSet ? price / 2 : price);    // band each appliance by half the set's combined price
    if (!tier) return;
    ensureCss();
    host.innerHTML =
      '<div class="neu-nsw">' +
        '<div class="neu-nsw__head">' +
          (LOGO ? '<img class="neu-nsw__logo" src="' + LOGO + '" alt="Neu Shield Extended Protection" width="48" height="38">' : '') +
          '<div class="neu-nsw__headtext">' +
            '<p class="neu-nsw__t">Neu Shield Extended Protection</p>' +
            '<p class="neu-nsw__s">Cover this appliance for up to 5 years. <button type="button" class="neu-nsw__info">What’s covered?</button></p>' +
          '</div>' +
        '</div>' +
        '<div class="neu-nsw__opts" role="radiogroup" aria-label="Neu Shield Extended Protection">' +
          optRow('', 'No thanks', '', '') +
          optRow(tier.y3.id, '3-Year Protection', planSub('3 years of parts &amp; labor coverage', isSet, tier.y3.price), '+ ' + money(tier.y3.price * qty)) +
          optRow(tier.y5.id, '5-Year Protection', planSub('Our best value — 5 full years', isSet, tier.y5.price), '+ ' + money(tier.y5.price * qty)) +
        '</div>' +
      '</div>';
    window.__neuWarranty = null;
    host.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'neu-nsw') return;
      host.querySelectorAll('.neu-nsw__opt').forEach(function (l) { l.classList.toggle('is-sel', l.contains(e.target)); });
      var id = e.target.value;
      if (!id) { window.__neuWarranty = null; return; }
      var term = (id === tier.y5.id) ? '5-Year' : '3-Year';
      window.__neuWarranty = { id: id, label: 'Neu Shield ' + term + ' Protection', term: term, forVariant: forVariant, qty: qty };
    });
    host.querySelector('.neu-nsw__info').addEventListener('click', openPopup);
  }
  // washer/dryer set: reframe the sub-label as per-appliance ("$139 each"); the price column shows the total
  function planSub(base, isSet, per) { return isSet ? ('Covers your washer &amp; dryer — ' + money(per) + ' each') : base; }
  function optRow(id, term, sub, priceLabel) {
    var isNone = (id === '');
    return '<label class="neu-nsw__opt' + (isNone ? ' neu-nsw__opt--none' : '') + '">' +
      '<input type="radio" name="neu-nsw" value="' + id + '"' + (isNone ? ' checked' : '') + '>' +
      '<span class="neu-nsw__radio" aria-hidden="true"></span>' +
      '<span class="neu-nsw__opt-main"><span class="neu-nsw__opt-term">' + term + '</span>' +
        (sub ? '<span class="neu-nsw__opt-sub">' + sub + '</span>' : '') + '</span>' +
      (priceLabel ? '<span class="neu-nsw__opt-price">' + priceLabel + '</span>' : '') +
      '</label>';
  }

  /* ================= Cart upsell (per appliance) ================= */
  function initCart() {
    var slots = document.querySelectorAll('.neu-cart-upsell:not([data-neu-ready])');
    if (!slots.length) return;
    ensureCss();
    slots.forEach(function (slot) {
      slot.setAttribute('data-neu-ready', '1');
      LOGO = slot.getAttribute('data-logo') || LOGO;
      var isSet = slot.getAttribute('data-wdset') === '1';   // washer/dryer set = two appliances
      var qty = isSet ? 2 : 1;
      var basePrice = parseFloat(slot.getAttribute('data-price') || '0');
      var tier = tierFor(slot.getAttribute('data-type'), isSet ? basePrice / 2 : basePrice);
      if (!tier) return;
      var v = slot.getAttribute('data-variant');
      slot.innerHTML =
        '<div class="neu-cup">' +
          '<span class="neu-cup__label">' + (isSet ? 'Protect your washer &amp; dryer?' : 'Add Neu Shield protection?') + '</span>' +
          '<button type="button" class="neu-cup__btn" data-id="' + tier.y3.id + '" data-term="3-Year" data-qty="' + qty + '" data-for="' + v + '">3-Year ' + money(tier.y3.price * qty) + '</button>' +
          '<button type="button" class="neu-cup__btn" data-id="' + tier.y5.id + '" data-term="5-Year" data-qty="' + qty + '" data-for="' + v + '">5-Year ' + money(tier.y5.price * qty) + '</button>' +
          '<button type="button" class="neu-cup__info">What’s covered?</button>' +
        '</div>';
    });
  }
  // Cart-drawer section id(s), so /cart/add.js returns rendered section HTML for Horizon to morph in.
  function cartSectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (c) {
      var id = c.dataset && c.dataset.sectionId; if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }
  // Let Horizon re-render its own drawer. The theme's cart-items-component listens for
  // shopify:cart:lines-update and morphs in event.promise's resolved { sections } (falling back to
  // fetching the section itself). A raw section swap loses the JS-rendered line items — hence the blank
  // cart bug — so we hand the theme the rendered HTML and let it morph, exactly like a native add.
  function notifyCartUpdated(resp) {
    var ev;
    try { ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true }); }
    catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('shopify:cart:lines-update', true, false, null); }
    ev.promise = Promise.resolve({ detail: resp || {} });
    document.dispatchEvent(ev);
  }
  // delegated click for cart upsell add + popup (survives cart re-renders)
  document.addEventListener('click', function (e) {
    var info = e.target.closest && e.target.closest('.neu-cup__info');
    if (info) { openPopup(); return; }
    var btn = e.target.closest && e.target.closest('.neu-cup__btn');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var wrap = btn.closest('.neu-cup'); if (wrap) wrap.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: btn.getAttribute('data-id'), quantity: parseInt(btn.getAttribute('data-qty') || '1', 10), properties: { _neu_warranty: btn.getAttribute('data-term'), _neu_warranty_for: btn.getAttribute('data-for') } }],
        sections: cartSectionIds(), sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); })
      .then(function (resp) { notifyCartUpdated(resp); })
      .catch(function () { location.reload(); });
  });

  /* ================= "What's covered?" popup (shared) ================= */
  function openPopup() {
    var m = document.getElementById('neu-nsw-modal');
    if (!m) {
      m = document.createElement('div'); m.id = 'neu-nsw-modal'; m.className = 'neu-nsw-modal';
      m.innerHTML =
        '<div class="neu-nsw-modal__panel" role="dialog" aria-modal="true" aria-label="Neu Shield coverage">' +
          '<button type="button" class="neu-nsw-modal__x" aria-label="Close">×</button>' +
          (LOGO ? '<img class="neu-nsw-modal__logo" src="' + LOGO + '" alt="Neu Shield Extended Protection">' : '') +
          '<p class="neu-nsw-modal__lead">A single repair can cost more than the plan. Neu Shield covers what the manufacturer’s warranty doesn’t, for up to 5 years.</p>' +
          '<ul class="neu-nsw-modal__list">' +
            li('Parts &amp; labor on qualified repairs, with no deductibles or hidden charges') +
            li('Mechanical, electrical &amp; manufacturer defects from normal use') +
            li('Up to 3 onsite visits by an appliance technician') +
            li('Power surge protection &amp; repair-or-replace guarantee') +
            li('$300 food-loss credit (refrigerators &amp; freezers)') +
            li('$100 laundry reimbursement (washers &amp; dryers)') +
            li('$100 dine-out credit &amp; $100 recycling credit') +
            li('24/7 online claims, fully transferable, backed by an A-rated insurer') +
          '</ul>' +
          '<p class="neu-nsw-modal__fine">Limitations and exclusions apply; not all claims are eligible. ' +
          '<a href="https://newleafsc.net/metro/terms" target="_blank" rel="noopener">See full terms &amp; conditions</a>. Powered by New Leaf.</p>' +
        '</div>';
      document.body.appendChild(m);
      function close() { m.hidden = true; }
      m.addEventListener('click', function (e) { if (e.target === m) close(); });
      m.querySelector('.neu-nsw-modal__x').addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
    }
    m.hidden = false;
  }
  function li(t) { return '<li>' + t + '</li>'; }

  function ensureCss() {
    if (document.getElementById('neu-nsw-css')) return;
    var s = document.createElement('style'); s.id = 'neu-nsw-css';
    s.textContent =
      '.neu-nsw{border:1px solid #e6dced;border-radius:16px;padding:18px 18px 16px !important;background:#fff;box-shadow:0 3px 14px rgba(38,24,73,.07);font-family:Montserrat,system-ui,sans-serif;}' +
      '.neu-nsw__head{display:flex;align-items:center;gap:13px;margin:0 0 15px !important;}' +
      '.neu-nsw__logo{flex:0 0 auto;width:48px;height:auto;}.neu-nsw__headtext{min-width:0;}' +
      '.neu-nsw__t{margin:0 !important;font-weight:800;color:#261849;font-size:1rem;line-height:1.25;letter-spacing:.01em;}' +
      '.neu-nsw__s{margin:5px 0 0 !important;font-size:.82rem;color:#6b6672;line-height:1.4;}' +
      '.neu-nsw__info{background:none;border:none;padding:0;margin:0 0 0 4px !important;color:#7947a8;font:inherit;font-size:.82rem;font-weight:700;text-decoration:underline;cursor:pointer;}.neu-nsw__info:hover{color:#261849;}' +
      '.neu-nsw__opts{display:flex !important;flex-direction:column;gap:10px !important;}' +
      '.neu-nsw__opt{position:relative;display:flex !important;align-items:center;gap:13px;border:1.5px solid #e6dced;border-radius:12px;padding:14px 16px !important;cursor:pointer;transition:border-color .15s,background .15s,box-shadow .15s;}' +
      '.neu-nsw__opt:hover{border-color:#c9a6ce;background:#faf7fb;}' +
      '.neu-nsw__opt input{position:absolute;opacity:0;width:0;height:0;margin:0;}' +
      '.neu-nsw__radio{flex:0 0 auto;width:21px;height:21px;border-radius:50%;border:2px solid #c1a3c6;display:grid;place-items:center;transition:border-color .15s;}' +
      '.neu-nsw__radio::after{content:"";width:11px;height:11px;border-radius:50%;background:#7947a8;transform:scale(0);transition:transform .15s ease;}' +
      '.neu-nsw__opt input:checked ~ .neu-nsw__radio{border-color:#7947a8;}.neu-nsw__opt input:checked ~ .neu-nsw__radio::after{transform:scale(1);}' +
      '.neu-nsw__opt input:focus-visible ~ .neu-nsw__radio{outline:2px solid #7947a8;outline-offset:2px;}' +
      '.neu-nsw__opt.is-sel:not(.neu-nsw__opt--none){border-color:#f7c407;background:#fffbe9;box-shadow:0 3px 12px rgba(247,196,7,.2);}' +
      '.neu-nsw__opt.is-sel:not(.neu-nsw__opt--none) .neu-nsw__radio{border-color:#7947a8;}' +
      '.neu-nsw__opt-main{flex:1 1 auto;min-width:0;display:flex !important;flex-direction:column;gap:2px;}' +
      '.neu-nsw__opt-term{font-weight:700;color:#261849;font-size:.92rem;line-height:1.2;}' +
      '.neu-nsw__opt-sub{font-size:.74rem;color:#948e9c;line-height:1.25;}' +
      '.neu-nsw__opt-price{flex:0 0 auto;font-weight:800;color:#261849;font-size:1.02rem;white-space:nowrap;}' +
      '.neu-nsw__opt--none{padding:12px 16px !important;}.neu-nsw__opt--none .neu-nsw__opt-term{font-weight:600;color:#8a8590;font-size:.84rem;}' +
      /* cart upsell */
      '.neu-cart-upsell{margin-top:8px;}' +
      '.neu-cup{display:flex;flex-wrap:wrap;align-items:center;gap:8px;border:1px dashed #d3a5d8;border-radius:10px;padding:8px 10px;background:#faf7fb;font-family:Montserrat,system-ui,sans-serif;}' +
      '.neu-cup.is-loading{opacity:.6;pointer-events:none;}' +
      '.neu-cup__label{font-size:.76rem;font-weight:700;color:#261849;margin-right:2px;}' +
      '.neu-cup__btn{border:1.5px solid #7947a8;background:#fff;color:#261849;border-radius:8px;padding:5px 10px;font:inherit;font-size:.76rem;font-weight:700;cursor:pointer;transition:background .15s,color .15s;}' +
      '.neu-cup__btn:hover{background:#7947a8;color:#fff;}' +
      '.neu-cup__info{background:none;border:none;padding:0;color:#7947a8;font:inherit;font-size:.72rem;font-weight:600;text-decoration:underline;cursor:pointer;margin-left:auto;}' +
      '.neu-nsw-modal{position:fixed;inset:0;z-index:2147483040;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(20,12,40,.55);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);}' +
      '.neu-nsw-modal[hidden]{display:none;}' +
      '.neu-nsw-modal__panel{position:relative;background:#fff;border-radius:16px;max-width:420px;width:100%;padding:26px 24px 22px;box-shadow:0 20px 60px rgba(38,24,73,.4);font-family:Montserrat,system-ui,sans-serif;max-height:90vh;overflow:auto;}' +
      '.neu-nsw-modal__x{position:absolute;top:10px;right:12px;background:none;border:none;font-size:26px;line-height:1;color:#7a7580;cursor:pointer;}' +
      '.neu-nsw-modal__logo{display:block;width:118px;height:auto;margin:0 auto 14px;}' +
      '.neu-nsw-modal__lead{margin:0 0 16px;font-size:.9rem;line-height:1.45;color:#261849;font-weight:600;text-align:center;}' +
      '.neu-nsw-modal__list{list-style:none;margin:0 0 16px;padding:0;display:flex;flex-direction:column;gap:10px;}' +
      '.neu-nsw-modal__list li{position:relative;padding-left:28px;font-size:.84rem;line-height:1.4;color:#3a3540;}' +
      '.neu-nsw-modal__list li::before{content:"";position:absolute;left:0;top:1px;width:18px;height:18px;border-radius:50%;background:#f7c407;}' +
      '.neu-nsw-modal__list li::after{content:"\\2713";position:absolute;left:4px;top:0;font-size:12px;font-weight:900;color:#261849;}' +
      '.neu-nsw-modal__fine{margin:0;font-size:.72rem;line-height:1.4;color:#948e9c;text-align:center;}.neu-nsw-modal__fine a{color:#7947a8;font-weight:700;}';
    document.head.appendChild(s);
  }

  /* Re-hydrate the cart upsell whenever the cart drawer re-renders. Horizon replaces the
     cart-drawer section's inner HTML via the Section Rendering API on add-to-cart / qty change,
     injecting a FRESH (un-hydrated) .neu-cart-upsell placeholder. Without this, the upsell is
     blank until a full page reload runs boot() again. initCart() guards on [data-neu-ready], so
     re-running on every cart mutation is idempotent and cheap. */
  // Debounce with setTimeout (not rAF): rAF is paused in background/hidden tabs, which would strand
  // the guard flag and stop the upsell from ever hydrating if the cart changed while backgrounded.
  var _cartT = 0;
  function hydrateCartSoon() {
    if (_cartT) return;
    _cartT = setTimeout(function () { _cartT = 0; initCart(); }, 60);
  }
  function watchCart() {
    // Primary signal: Horizon dispatches the Shopify Storefront cart events on add / qty change and
    // re-renders the cart-drawer section around them, injecting a fresh (un-hydrated) upsell placeholder.
    // The re-render can land a frame or two after the event, so hydrate now AND again once it settles.
    ['shopify:cart:lines-update', 'shopify:cart:update', 'shopify:cart:add', 'shopify:cart:lines-add',
     'cart:refresh', 'cart:update', 'cart:updated', 'cart:add', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { hydrateCartSoon(); setTimeout(hydrateCartSoon, 200); });
    });
    // Backup signal: a light-DOM observer on <body> catches any cart re-render the events miss. Cheap +
    // safe — initCart() short-circuits when no un-hydrated slots remain, so it never loops on its own writes.
    try { new MutationObserver(hydrateCartSoon).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }

  function boot() { initPdp(); initCart(); watchCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
